// #42484: Special labels for calendars on charts
import _ from 'lodash'

const customCalendarLabels = {
	daily: 'admin.calendar.day',
	weekly: 'admin.calendar.week',
	monthly: 'admin.calendar.month',
	quarterly: 'admin.calendar.quarter',
	yearly: 'admin.calendar.year',
	'fiscal-quarterly': 'admin.calendar.usgovernment.quarter',
	'fiscal-yearly': 'admin.calendar.usgovernment.year'
}

function mapCalendarsToCalendarsWithCustomLabels(calendars) {
	return calendars.map(calendar =>
		_.defaults({
			label: customCalendarLabels[calendar.type]
		}, calendar)
	)
}

export default {
	customCalendarLabels,
	mapCalendarsToCalendarsWithCustomLabels
}